#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query InvoiceEmailStatus($id: UUID!) {
  invoice(id: $id) {
    id   
    _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
